import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ChannelWidget } from '@shared/assets/icons/components';
import { EmptyListState } from '@shared/ui/empty-list-state';

interface PresetsEmptyStateProps {
  onCreate: () => void;
}

export const PresetsEmptyState: FC<PresetsEmptyStateProps> = ({ onCreate }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'presets' });

  return (
    <EmptyListState
      title={t('empty.title')}
      description={t('empty.description')}
      action={t('actions.create')}
      icon={ChannelWidget}
      onAction={onCreate}
    />
  );
};
